import { PackageType, ProductType } from './types';
import { formatMoney, formatMonthDayYear } from '../../utils/utils';
import { isEmpty } from 'lodash';

export const getTicketConfiguation = (ticket: PackageType['tickets'][0]) => {
  return [
    {
      label: 'Departure date',
      value: formatMonthDayYear(+ticket.departure.date)
    },
    { label: 'Reference', value: ticket.departure.reference },
    ...(ticket.return
      ? [
          { label: 'Return date', value: ticket.return.date ? formatMonthDayYear(+ticket.return.date) : null },
          { label: 'Reference', value: ticket.return.reference }
        ]
      : []),
    { label: 'Number of passengers', value: ticket.numberOfPassengers.toString() },
    { label: 'Notes', value: ticket.notes },
    { label: 'Total amount', value: formatMoney(ticket.total || 0) }
  ];
};

export const getHotelConfiguation = (hotel: PackageType['hotels'][0]) => {
  return [
    {
      label: 'Check in',
      value: formatMonthDayYear(+hotel.checkIn)
    },
    {
      label: 'Check out',
      value: formatMonthDayYear(+hotel.checkOut)
    },
    { label: 'Adults', value: hotel.adults.toString() },
    ...(hotel.children ? [{ label: 'Children', value: hotel.children.toString() }] : []),
    ...(hotel.infants ? [{ label: 'Infants', value: hotel.infants.toString() }] : []),
    ...(hotel.childrenAge ? [{ label: 'Children age', value: hotel.childrenAge }] : []),
    { label: 'Room type', value: hotel.roomType },
    { label: 'Board', value: hotel.board },
    { label: 'View', value: hotel.view },
    { label: 'Extras', value: hotel.extra },
    { label: 'Notes', value: hotel.notes },
    {
      label: 'Total amount',
      value: hotel.partnerPayment?.total?.amount ? formatMoney(hotel.partnerPayment?.total?.amount) : '-'
    }
  ];
};

export const getTransferConfiguration = (transfer: PackageType['transfers'][0]) => {
  return [
    {
      label: 'Pick up',
      value: formatMonthDayYear(+transfer.dates[0])
    },
    ...(transfer.dates[1] ? [{ label: 'Drop off', value: formatMonthDayYear(+transfer.dates[1]) }] : []),
    { label: 'Notes', value: transfer.notes },
    {
      label: 'Total amount',
      value: transfer.partnerPayment?.total?.amount ? formatMoney(transfer.partnerPayment?.total?.amount) : '-'
    }
  ];
};

export const getInsuranceConfiguration = (insurance: PackageType['insurances'][0]) => {
  return [
    {
      label: 'Notes',
      value: insurance.notes
    },
    {
      label: 'Total amount',
      value: insurance.partnerPayment?.total?.amount ? formatMoney(insurance.partnerPayment?.total?.amount) : '-'
    }
  ];
};

export const getExtraConfiguration = (extra: PackageType['extras'][0]) => {
  return [
    {
      label: 'Notes',
      value: extra.notes
    },
    {
      label: 'Total amount',
      value: extra.partnerPayment?.total?.amount ? formatMoney(extra.partnerPayment?.total?.amount) : '-'
    }
  ];
};

export const getAvailableProducts = (packageDetails: PackageType): ProductType[] => {
  const products: Array<{ value: any[]; key: ProductType }> = [
    { value: packageDetails.hotels, key: 'hotel' },
    { value: packageDetails.tickets, key: 'ticket' },
    { value: packageDetails.transfers, key: 'transfer' },
    { value: packageDetails.insurances, key: 'insurance' },
    { value: packageDetails.extras, key: 'extra' }
  ];

  return products.filter((product) => !isEmpty(product.value)).map((product) => product.key);
};
